import styled from 'styled-components';
import { Download } from '@styled-icons/boxicons-regular/Download';
import { ShoppingCart } from '@styled-icons/material-outlined/ShoppingCart';
import { DraftingCompass } from '@styled-icons/fa-solid/DraftingCompass';
import { PlusSquare } from '@styled-icons/fa-solid/PlusSquare';
import { Modal } from 'antd';

export const WhiteBlockContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  padding: 1.5rem;
  margin-bottom: 0.5rem;
`;

export const Container = styled.section`
  width: 97%;
  max-width: 100%;
  margin: 1rem auto;

  & > header > .title {
    font-size: 1.625rem;
    color: ${({ theme }) => theme.colors.grayDark2};
    font-weight: 700;
    margin-bottom: 1.25rem;
  }
`;

export const FaceliftContainer = styled.section<{ lastItem?: boolean }>`
  padding: 1rem 0;
  background-color: ${({ theme }) => theme.colors.white};

  ${({ lastItem, theme }) =>
    !lastItem &&
    `
      border-bottom: 0.5rem solid ${theme.colors.grayLight};
  `}
`;

export const ContainerTitle = styled.div<{ isNewTitleFacelift: boolean }>``;

export const ActionsContainer = styled.div<{ isNewTitleFacelift: boolean }>`
  margin-top: ${({ isNewTitleFacelift }) =>
    isNewTitleFacelift ? '1.5rem' : '0.25rem'};
  margin-left: ${({ isNewTitleFacelift }) => isNewTitleFacelift && '1rem'};
  & > span {
    font-size: 0.875rem;
  }

  & > .actions {
    display: flex;

    flex-direction: column;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobileL}) {
      flex-direction: row;
    }

    & > button {
      display: flex;
      align-items: center;
      font-size: 0.875rem;
      max-width: 15rem;
      margin-left: ${({ isNewTitleFacelift }) => isNewTitleFacelift && '-1rem'};

      @media (min-width: ${({ theme }) => theme.breakpoints.mobileL}) {
        &:first-child {
          margin-right: ${({ isNewTitleFacelift }) =>
            isNewTitleFacelift ? '2rem' : '1rem'};
        }
      }
    }
  }
`;

export const DetailingProjectIcon = styled(DraftingCompass)`
  width: 1.25rem;
  color: ${({ theme }) => theme.colors.white};
`;

export const PlusSquareIcon = styled(PlusSquare)`
  width: 1.125rem;
  color: ${({ theme }) => theme.colors.white};
`;

export const DownloadPdfIcon = styled(Download)`
  width: 1rem;
  margin-right: 0.625rem;
`;

export const RebuyIcon = styled(ShoppingCart)`
  width: 1rem;
  margin-right: 0.625rem;
`;

export const OrderInProgressModal = styled(Modal)`
  & .ant-modal-header {
    border-bottom: none;

    & > div {
      font-size: 1.25rem;
      color: ${({ theme }) => theme.colors.grayDark2};
    }
  }

  & .ant-modal-body {
    padding: 0 1.5rem 0.5rem;
    & > span {
      font-size: 1rem;
      color: ${({ theme }) => theme.colors.grayDark2};
    }
  }

  & .ant-modal-footer {
    border-top: none;
  }
`;

export const SubTitle = styled.span`
  font-family: ${({ theme }) => theme.fonts.workSans};
  font-size: '1rem';
  font-weight: 400;
  color: ${({ theme }) => theme.colors.grayDark4};
`;

export const TitleContainer = styled.div`
  padding: 0 1rem 0 1.5rem;
  background-color: ${({ theme }) => theme.colors.white};
`;

export const TableContainer = styled.div`
  padding: 1rem 1.5rem;
  background-color: ${({ theme }) => theme.colors.grayLight};
`;
